import Node from 'nanogl-node'

import { BonusType } from '@/webgl/runner/entities/BonusEntity'

export enum CollectibleType {
  Standard = 0,
  Obstacle = 1,
  TurningPoint = 2,
  Bonus = 3,
}

export enum CollectStatus {
  Neutral = 0,
  Succeed = 1,
  Failed = 2,
}

export type CollectibleData = {
  id: string
  type: CollectibleType
  bonus?: BonusType
  chill?: boolean
  canSwitch?: boolean
  audio?: string
  variants?: string[]
  prices?: number[]
}

export type CollectibleSwitch = {
  suffix: string
  apply: boolean
  progress: number
  speed: number
  unwrap?: boolean
}

export type CollectibleEntity = {
  uuid: string
  node: Node
  scale: number
  lane: number
  seed: number
  spawntime: number
  lifetime: number
  releasing: boolean
  collected: boolean
  collectedTime: number
  collectStatus: CollectStatus
  data: CollectibleData
  switch: CollectibleSwitch
  highlight: boolean
  blur: number
  variant?: string
  priceID?: number
  mirrored?: boolean
  y: number
}

export function getCollectibleSwitchFromBonus(bonus: BonusType, switchProgress: number = 1): CollectibleSwitch {
  switch (bonus) {
    case BonusType.Chart:
      return {
        suffix: 'shape',
        progress: switchProgress,
        apply: switchProgress >= 0.5,
        speed: 2.5,
      }
    // case BonusType.Switch:
    //   return {
    //     suffix: "switch",
    //     progress: switchProgress,
    //     apply: switchProgress >= 0.5,
    //     speed: 2.5,
    //     unwrap: true
    //   };
    default:
      return null
  }
}
